import React, { Component } from 'react'
import { Box, Fade, Popper, styled } from '@mui/material'
import { PanelNotFound } from './ui.units'
import { IDataViewContext, mapDataViewContext } from './context'
import createSortMenu from './create.sort-menu'
import createFilterMenu from './create.filter-menu'
import createSearchMatch from './create.search-match'

export function createPopperPanel<T>() {
  const SearchMatchInstance = createSearchMatch<T>()
  const FilterMenuInstance = createFilterMenu<T>()
  const SortMenuInstance = createSortMenu<T>()

  class Panel extends Component {
    render() {
      return mapDataViewContext((context) => {
        const { keyword, anchorEl, area } = context
        const isOpen = Boolean(anchorEl) && (!!keyword || area !== 'input')
        return (
          <Popper anchorEl={anchorEl} open={isOpen} placement='bottom-start' transition sx={{ zIndex: 1350, maxWidth: '100%' }}>
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={0}>
                <PannelWrap>{this.renderPanelContent(context)}</PannelWrap>
              </Fade>
            )}
          </Popper>
        )
      })
    }

    renderPanelContent = (context: IDataViewContext<T>) => {
      switch (context.area) {
        case 'input':
          return <SearchMatchInstance />
        case 'filterButton':
          return <FilterMenuInstance />
        case 'sortButton':
          return <SortMenuInstance />
        default:
          return <PanelNotFound area={context.area} />
      }
    }
  }
  return Panel
}
export default createPopperPanel

const PannelWrap = styled(Box)(({ theme }) => ({
  borderRadius: '4px',
  boxShadow: 'rgba(0, 0, 0, 0.06) 0px 5px 22px, rgba(0, 0, 0, 0.04) 0px 0px 0px 0.5px',
  backgroundColor: theme.palette.background.paper
}))
